var map = {
	"./": 466,
	"./development": 1396,
	"./development.js": 1396,
	"./index": 466,
	"./index.js": 466,
	"./preprod": 1397,
	"./preprod.js": 1397,
	"./production": 1377,
	"./production.js": 1377,
	"./staging": 1398,
	"./staging.js": 1398
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3388;